import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import Icon from './Icon';
import {addDecimals} from '../lib/utils';
import styled, {css} from 'styled-components';

const colorOptionStyles = `
  > div {
    > button {
      height: 60px;
      width: 60px;
      background-color: #eee;
    }
    &:first-child {
      width: calc(100% - 60px);
    }
    &:last-child {
      width: 60px;
      padding: 0 16px;
      background-color: transparent;
      > button {
        background-color: #fff;
        width: 24px;
        height: 24px;
        border-radius: 2px;
        margin: 0 auto;
        top: 50%;
        transform: translateY(-50%);
        i {
          width: 14px;
          height: 14px;
          border-radius: 2px;
          border-width: 1px;
          border-style: solid;
          svg {
            fill: #FFF;
            width: 10px;
            height: 10px;
            margin: 1px auto 0 auto;
          }
        }
      }
    }
  }
`

const compactStyles = `
> div {
  &:only-child {
    width: 100%;
    margin: 0;
    padding: 0 16px;
    background-color: #fff;
    > div {
      margin: 0;
    }
  }
}
`

const StyledProduct = styled.div`
  background-color: #eee;
  opacity: ${props => props.disabled ? .4 : 1};
  pointer-events: ${props => props.disabled ? "none" : "all"};
  height: 60px;
  width: 100%;
  clear: both;
  display: inline-block;
  /* Select/Radio/Name */
  > div:first-child {
    width: 45%;
    height: 100%;
    background-color: #fff;
    display: inline-block;
    vertical-align: middle;
    position: relative;
    text-transform: uppercase;
    padding: 0 16px;
    box-shadow: 0px 0px 10px 0 rgba(51,51,51,0.10);
    z-index: 4;
    @media (min-width: 640px) {
      width: 30%;
    }
    @media (min-width: 1280px) {
      width: 20%;
    }
    > div {
      position: relative;
      top: 50%;
      transform: translateY(-50%);
      input[type="checkbox"] {
        position: relative;
        z-index: 3;
        display: none;
        + label::before {
          cursor: pointer;
          position: relative;
          width: 14px;
          height: 14px;
          background-color: #eee;
          display: block;
          content: "";
          top: 1px;
          float: left;
          margin-right: 16px;
          border-radius: 7px;
          z-index: 2;
          border: 2px solid #eee;
        	-webkit-transition: all .2s ease-in-out;
        	-moz-transition: all .2s ease-in-out;
        	-o-transition: all .2s ease-in-out;
        	transition: all .2s ease-in-out;
        }
        &:checked {
          + label::before {
            border: 2px solid #eee;
            background-color: #333;
          }
        }
      }
      label {
        font-size: .875em;
        position: relative;
        z-index: 2;
        cursor: pointer;
        display: inline-block;
        height: auto;
        min-height: 14px;
        width: 100%;
        > a {
          text-decoration: none;
          color: #333;
          display: block;
        	-webkit-transition: all .2s ease-in-out;
        	-moz-transition: all .2s ease-in-out;
        	-o-transition: all .2s ease-in-out;
        	transition: all .2s ease-in-out;
          margin-left: 30px;
          position: absolute;
          left: 0;
          top: calc(50% + 1px);
          -webkit-transform: translateY(-50%);
          -ms-transform: translateY(-50%);
          transform: translateY(-50%);
          width: calc(100% - 30px);
          &:hover {
            color: #21A0D2;
          }
          small {
            text-transform: none;
            font-size: .875em;
          }
        }
      }
    }
  }

  /* Properties */
  > div:last-child {
    width: 55%;
    height: 100%;
    background-color: #F6F6F6;
    display: inline-block;
    vertical-align: middle;
    padding: 0 30px;
    position: relative;
    z-index: 1;
    @media (min-width: 640px) {
      width: 70%;
    }
    @media (min-width: 1280px) {
      width: 80%;
    }
    /* Skip */
    > button {
      position: absolute;
      top: 0;
      z-index: 3;
      padding: 0;
      width: 32px;
      height: 100%;
      background-color: #F6F6F6;
      > i {
        margin: 0 auto;
        svg {
          stroke-width: 2;
          stroke: #000;
        }
      }
      &:first-child {
        left: 0;
      }
      &:last-child {
        right: 0;
      }
      /* Choose Color */
      &.choose_color {
        > i {
          background: ${
            props => props.color ? props.color : "#fff"
          };
          border-color: ${
            props => props.color ? props.color : "#eee"
          };
        }
      }
    }
    /* Values */
    > div {
      position: absolute;
      width: auto;/*calc(800% - 64px);*/
      /* width: calc(${props => props.cnt} * 100% - 64px); */
      margin: 0 32px;
      top: 50%;
      transform: translateY(-50%);
      line-height: 1;
      left: ${props => props.left+"px"};
      white-space: nowrap;
      z-index: 2;
      -webkit-transition: all .3s ease-in-out;
      -moz-transition: all .3s ease-in-out;
      -o-transition: all .3s ease-in-out;
      transition: all .3s ease-in-out;

      > span {
        font-size: .875em;
        width: 110px;
        display: inline-block;
        padding: 0 10px 0 0;
        color: #666;
        vertical-align: middle;
        white-space: normal;
        &.collapsed {
          width: 70px;
        }
        @media (min-width: 480px) {
          font-size: 1em;
          width: 130px;
        }
      }
    }
  }

  & {
    ${props => props.compact ? css`${compactStyles}` : ``};
  }

  & {
    ${props => props.colorOption ? css`${colorOptionStyles}` : ``}
  }
`;

export default function ProductListed (props) {
  const {data, selected, compact, colorOption, scrolled, left, toggle, toggleLayer, onMouseEnter, onMouseLeave, toggleProp, listed, max, onStep} = props;
  const {id, name, url, color, properties, disabled, track} = data || {};
  return (
    <StyledProduct disabled={disabled} colorOption={colorOption} color={color} left={left} cnt={compact ? 1 : properties.length} compact={compact} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      <div>
        <div>
          <input type="checkbox" id={id} value={id} onChange={() => toggle(id)} checked={selected}/>
          <label htmlFor={id}>
            <a href={url} target="_blank" rel="noopener noreferrer" onClick={track}>{name} {disabled && <small>- Wax</small>}</a>
          </label>
        </div>
      </div>
    {compact && props.colorOption && (
      <div>
        <Button className="choose_color" icon="brush" stroke="none" fill={color ? "#FFF" : "#BBB"} onClick={toggleLayer} bg={color || "#fff"} />
      </div>
    )}
    {!compact && (
      <div className="props">
        <Button disabled={max === "left"} icon="left" onClick={() => onStep("left")}/>
        <div>
        {!!properties && properties.map((item, index) => {
          const value = item.value === -1 || item.value === "" ? "N/A"
            : item.type === "sensory" ? item.classified
            : addDecimals(item);
          return (
          <span
            key={index}
            className={listed[index] && listed[index].collapsed ? "collapsed" : null}
            title={value}
          >
            {listed[index] && listed[index].collapsed ?
              <Icon name="expand" onClick={() => toggleProp(index)}/>
              : value
            }
          </span>)}
        )}
        </div>
        <Button disabled={max === "right"} icon="right" onClick={() => onStep("right")}/>
      </div>
    )}
    </StyledProduct>
  )
}

ProductListed.propTypes = {
  data: PropTypes.object
};
